import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebaseConfig'; 
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import styles from './Hero.module.css';
import { timeAgo } from '../Dashboard/timeUtils'; 

// Existing components
import NewsGrid from './NewsGrid';
import Sports from './Sports';
import EducationSystem from './Education';
import VideoSection from './Videos';
import International from './International';
import Entertainment from './Entertainment';
import Business from './Bussiness';
import Health from './Health';
import Politics from './Politics';
import Engagement from './Engagement';
import Finance from './Finance';
import Lifestyle from './LifeStyle';
import Footer from './Footer';

const Hero = ({ lang = 'EN' }) => {
  const [featured, setFeatured] = useState(null);
  const [trendingNews, setTrendingNews] = useState([]);
  const [moreNews, setMoreNews] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const q = query(collection(db, "news"), orderBy("timestamp", "desc"));
        const querySnapshot = await getDocs(q);
        const allNews = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        if (allNews.length > 0) {
          // 1. Sabse pehli 'center' category wali news dhoondein, warna sabse nayi (latest) news ko center dein
          const centerNews = allNews.find(item => item.category === 'center') || allNews[0];
          setFeatured(centerNews);

          // 2. Baaki ki saari news jo center mein nahi hain
          const remainingNews = allNews.filter(item => item.id !== centerNews.id);
          
          // 3. Trending (Left side) news filter karein
          setTrendingNews(remainingNews.filter(item => item.category === 'trending'));
          
          // 4. More News (Right side): Purani center wali news sabse upar (top) hogi, baaki 'more' wali uske baad
          const oldCenterOrMore = remainingNews.filter(item => item.category === 'more' || !item.category || item.category === 'center');
          setMoreNews(oldCenterOrMore);
        }
      } catch (err) {
        console.error("Firebase Error:", err);
      }
    };
    fetchNews();
  }, []);

  return (
    <>
      <section className={styles.heroSection} dir={lang === 'UR' ? 'rtl' : 'ltr'}>
        
        {/* Left Column - Trending */}
        <div className={styles.leftColumn} style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <h3>{lang === 'EN' ? "TRENDING" : "ٹرینڈنگ"}</h3>
          {trendingNews.map((item) => (
            <Link to={`/news/${item.id}`} key={item.id} className={styles.newsItemLink}>
              <div className={styles.newsItem}>
                {item.randomHeroImage && <img src={item.randomHeroImage} alt="news" />}
                <div className={styles.cardInfo}>
                  <h4>{lang === 'EN' ? item.titleEn : item.titleUr}</h4>
                  <div style={{ fontSize: '11px', color: '#666', marginTop: '5px' }}>
                    {item.date && <span>{item.date} • </span>}
                    <span>{timeAgo(item.timestamp)}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Center Column - Featured */}
        <div className={styles.centerColumn}>
          {featured && (
            <Link to={`/news/${featured.id}`} className={styles.featuredLink}>
              <div className={styles.featured}>
                {featured.randomHeroImage && <img src={featured.randomHeroImage} alt="Main" />}
              </div>
              <h1 className={styles.featuredTitle}>{lang === 'EN' ? featured.titleEn : featured.titleUr}</h1>
            </Link>
          )}
        </div>

        {/* Right Column - More News */}
        <div className={styles.sidebar} style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <h3 className={styles.sidebarTitle}>{lang === 'EN' ? "MORE NEWS" : "مزید خبریں"}</h3>
          {moreNews.map((item) => (
            <Link to={`/news/${item.id}`} key={item.id} className={styles.sideItem}>
              <h4>{lang === 'EN' ? item.titleEn : item.titleUr}</h4>
              <div style={{ fontSize: '11px', color: '#666', marginTop: '5px' }}>
                {item.date && <span>{item.date} • </span>}
                <span>{timeAgo(item.timestamp)}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Components */}
      <NewsGrid lang={lang} />
      <EducationSystem lang={lang} />
      <Sports lang={lang} />
      <VideoSection lang={lang} />
      <International lang={lang} />
      <Entertainment lang={lang} />
      <Business lang={lang} />
      {/* <Health lang={lang} /> */}
      <Politics lang={lang} />
      <Engagement lang={lang} />
      <Finance lang={lang} />
      <Lifestyle lang={lang} />
      <Footer lang={lang} />
    </>
  );
};

export default Hero;